import type { ZodSchema, z } from 'zod';

export const safeParseAsync = async <T extends ZodSchema>(
  zodSchema: T,
  entity: unknown,
  errorPrefix: string
): Promise<z.infer<T>> => {
  const parsed = await zodSchema.safeParseAsync(entity);
  if (parsed.success) {
    return parsed.data;
  } else {
    if (process.env['NODE_ENV'] !== 'production') {
      console.warn(
        `[ZodError/${errorPrefix}] ${JSON.stringify(parsed.error.format())}`
      );
    }
    return entity as T;
  }
};
